import React, { useState,useEffect,useMemo } from 'react';
import { Loader2,Plus, Wallet, CreditCard, Building2, ArrowUpRight, ArrowDownLeft, Filter, Search, Calendar, DollarSign } from 'lucide-react';
import config from '../config/config';
import axios from 'axios';
 
const PettyCashManager = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState('');
  const [reference, setReference] = useState('');
  const [selectedAccount, setSelectedAccount] = useState('');
   const[ balance,setPettyCashCurrentBalance]= useState(0);
      const[current_total_transactions, setPettyCashCurrentUsed]= useState(0);
      const[current_total_transactions_count, setPettyCashCurrentTransactions]= useState(0);
      const[transactionzz, setPettyCashCurrentActivities]= useState({});
      const[expensez, setPettyCashCurrentExpenses]= useState({});
      const[topups, setPettyCashCurrentTopUps]= useState({});
      const[transactions,setTransactions]=useState([]);
      const[accounts,setAccounts]=useState([]);

  /**const [accounts] = useState([
    { id: 'main', name: 'Main Business Account', balance: 45230.00, type: 'checking' },
    { id: 'savings', name: 'Business Savings', balance: 125000.00, type: 'savings' },
    { id: 'credit', name: 'Business Credit Line', balance: 15000.00, type: 'credit' }
  ]);**/

  const [transactionz, setTransactionz] = useState([
    { id: 1, type: 'expense', amount: 45.20, description: 'Office supplies - pens and paper', date: '2024-09-24', category: 'Office', recipient: 'Staples' },
    { id: 2, type: 'topup', amount: 500.00, description: 'Top-up from Main Business Account', date: '2024-09-23', category: 'Top-up', recipient: 'Internal' },
    { id: 3, type: 'expense', amount: 89.50, description: 'Team lunch - client meeting', date: '2024-09-23', category: 'Meals', recipient: 'Local Bistro' },
    { id: 4, type: 'expense', amount: 25.00, description: 'Parking fees downtown', date: '2024-09-22', category: 'Travel', recipient: 'City Parking' },
    { id: 5, type: 'expense', amount: 15.75, description: 'Coffee for morning meeting', date: '2024-09-22', category: 'Meals', recipient: 'Coffee House' },
    { id: 6, type: 'topup', amount: 1000.00, description: 'Top-up from Business Savings', date: '2024-09-20', category: 'Top-up', recipient: 'Internal' }
  ]);

   // Fetch benefits/deductions
  const fetchPettyCash = async (companyId = 1) => {
    setLoading(true);

    try {
      const response = await fetch(`${config.API_URL}/api/fetch-petty-cash/${companyId}/${startDate}/${endDate}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
     const data = await response.json();
      //console.log('Benefits/Deductions API response:', data);
      setPettyCashCurrentBalance(data.deposits || 0);
      setPettyCashCurrentUsed(data.payments || 0);
      setTransactions(data.transactions || []);
      setAccounts(data.accounts || []);
       //alert(response.data.deposits);
       setLoading(false);
     
      //console.log(response.data.accounts);
    } catch (err) {
      setLoading(false);
      //setError('Failed to fetch benefits/deductions');
      //console.error('Fetch benefits/deductions error:', err);
    }
  }; 

    const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) return decodeURIComponent(match[2]);
    return null;
  };
 const [searchTerm, setSearchTerm] = useState('');
 const [startDate, setStartDate] = useState('');
 const [endDate, setEndDate] = useState('');
  const filteredTransactions = useMemo(() => {
  if (!searchTerm.trim()) return transactions;

  const term = searchTerm.trim().toLowerCase();

  return transactions.filter(member => {
   return (
    member.description.toString().toLowerCase().includes(term)
);

  });
}, [searchTerm, transactions]);


  const handleTopUp = async () => {
    if (topUpAmount && selectedAccount) {
      const amount = parseFloat(topUpAmount);
      const account = accounts.find(acc => acc.id === selectedAccount);
      
     try {
      const payload = {
        amount: amount,
        account:account,
        reference:reference,
      };
       const token = localStorage.getItem('token');
      //console.log('Votehead payload:', payload);
       ////console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      ////console.log('CSRF Response:', csrfResponse);

      const xsrfToken = getCookie('XSRF-TOKEN');
      ////console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      const response = await axios.post(`${config.API_URL}/api/savePettyCash`, payload, {
            headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
          });
window.location.assign(`${config.APP_URL}/petty-cash`);
    
    } catch (err) {
      
      alert('Save petty-cash error:', err);
    } finally {
      setLoading(false);
    }
      
      
      setShowTopUpModal(false);
      setTopUpAmount('');
      setSelectedAccount('');
    }
  };

  const getAccountIcon = (type) => {
    switch(type) {
      case 'checking': return <Building2 className="w-4 h-4" />;
      case 'savings': return <Wallet className="w-4 h-4" />;
      case 'credit': return <CreditCard className="w-4 h-4" />;
      default: return <Building2 className="w-4 h-4" />;
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KSH'
    }).format(amount);
  };

    useEffect(() => {
    
    //console.log('Fetching initial data with token:', token);
    
    fetchPettyCash();
  }, [token]);

  const StatCard = ({ title, value, change, icon: Icon, trend = 'up' }) => (
    <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {change && (
            <p className={`text-sm font-medium mt-2 flex items-center ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
              {trend === 'up' ? <ArrowUpRight className="w-4 h-4 mr-1" /> : <ArrowDownLeft className="w-4 h-4 mr-1" />}
              {change}
            </p>
          )}
        </div>
        <div className="bg-gray-50 p-3 rounded-xl">
          <Icon className="w-6 h-6 text-gray-700" />
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
          <p className="text-base text-gray-600 font-medium">Loading petty cash...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Petty Cash</h1>
          <p className="text-gray-600">Manage your petty cash fund and track expenses</p>
        </div>
        <button 
          onClick={() => setShowTopUpModal(true)}
          className="bg-info text-white px-6 py-3 rounded-xl font-medium hover:bg-gray-800 transition-colors duration-200 flex items-center space-x-2 shadow-sm"
        >
          <Plus className="w-5 h-5" />
          <span>Top Up</span>
        </button>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <StatCard 
          title="Current Balance"
          value={formatCurrency(balance)}
          change=""
          icon={Wallet}
          trend="up"
        />
        <StatCard 
          title="This Month Spent"
          value={formatCurrency(current_total_transactions)}
          change=""
          icon={ArrowDownLeft}
          trend="down"
        />
     
      </div>

      {/* Navigation */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mb-6">
        <div className="flex border-b border-gray-100">
          {[
            { id: 'overview', label: 'Recent Activity' },
            { id: 'expenses', label: 'All Expenses' },
            { id: 'topups', label: 'Top-ups' }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors duration-200 ${
                activeTab === tab.id 
                  ? 'border-black text-black' 
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Search and Filter */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search transactions..."
                className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200"
              />
            </div>
            <div className="flex gap-3">
              
              <button  onClick={() => {setShowFilterModal(true); setLoading(false);}} className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors duration-200 flex items-center space-x-2">
                <Filter className="w-4 h-4" />
                <span className="text-sm font-medium">Filter By Date</span>
              </button>
            </div>
          </div>
        </div>

        {/* Transactions List */}
        <div className="divide-y divide-gray-100">
        {filteredTransactions.filter(t => {
  if (activeTab === 'expenses') return t.type === 'expense';
  if (activeTab === 'topups') return t.type === 'topup';
  return true;
}).map(transaction => (
            <div key={transaction.id} className="p-6 hover:bg-gray-50 transition-colors duration-150">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className={`p-3 rounded-xl ${
                    transaction.type === 'topup' 
                      ? 'bg-info-50 text-green-600' 
                      : 'bg-red-50 text-red-600'
                  }`}>
                    {transaction.type === 'topup' ? (
                      <ArrowUpRight className="w-5 h-5" />
                    ) : (
                      <ArrowDownLeft className="w-5 h-5" />
                    )}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 mb-1">{transaction.description}</p>
                    <div className="flex items-center space-x-3 text-sm text-gray-500">
                      <span>{transaction.recipient}</span>
                      <span>•</span>
                      <span>{transaction.category}</span>
                      <span>•</span>
                      <span>{new Date(transaction.date).toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`text-lg font-bold ${
                    transaction.type === 'topup' ? 'text-green-600' : 'text-red-600'
                  }`}>
                    {transaction.type === 'topup' ? '+' : '-'}{formatCurrency(Math.abs(transaction.amount))}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


      {showFilterModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Filter Petty Cash By Date</h2>
            
            <div className="space-y-6">
              
  <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                <div className="relative">
                  
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="0.00"
                    className="w-full pl-8 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200 text-lg"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                <div className="relative">
                  
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="0.00"
                    className="w-full pl-8 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200 text-lg"
                  />
                </div>
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  onClick={() => setShowFilterModal(false)}
                  className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={() => fetchPettyCash()}
                  disabled={!startDate || !endDate}
                  className="flex-1 py-3 px-4 bg-dark text-white rounded-xl font-medium hover:bg-gray-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200"
                >
                  Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Top-up Modal */}
      {showTopUpModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Top Up Petty Cash</h2>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">Select Account</label>
                <div className="space-y-3">
{accounts.length > 0 && accounts.map(account => (
                    <button
                      key={account.id}
                      onClick={() => setSelectedAccount(account.id)}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-200 text-left ${
                        selectedAccount === account.id
                          ? 'border-black bg-gray-50'
                          : 'border-gray-200 hover:border-gray-300'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="bg-gray-100 p-2 rounded-lg">
                            {getAccountIcon(account.type)}
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">{account.name}</p>
                            <p className="text-sm text-gray-500">Available: {formatCurrency(account.balance)}</p>
                          </div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
                <div className="relative">
                  
                  <input
                    type="number"
                    value={topUpAmount}
                    onChange={(e) => setTopUpAmount(e.target.value)}
                    placeholder="0.00"
                    className="w-full pl-8 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200 text-lg"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
                <div className="relative">
                  
                  <input
                    type="text"
                    value={reference}
                    onChange={(e) => setReference(e.target.value)}
                    placeholder="REF001"
                    className="w-full pl-8 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200 text-lg"
                  />
                </div>
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  onClick={() => setShowTopUpModal(false)}
                  className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleTopUp}
                  disabled={!topUpAmount || !selectedAccount || !reference}
                  className="flex-1 py-3 px-4 bg-info text-white rounded-xl font-medium hover:bg-gray-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200"
                >
                  Top Up
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PettyCashManager;